
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F","stroke-linecap":"round"}},[_c('path',{staticClass:"i-Vector",attrs:{"stroke-linejoin":"round","d":"M14.5 11.167V5.833a1.33 1.33 0 0 0-.667-1.153L9.167 2.014a1.33 1.33 0 0 0-1.334 0L3.167 4.68A1.33 1.33 0 0 0 2.5 5.833v5.333a1.33 1.33 0 0 0 .667 1.154l4.666 2.666a1.33 1.33 0 0 0 1.334 0l4.666-2.666a1.33 1.33 0 0 0 .667-1.154"}}),_c('path',{staticClass:"i-Vector_2",attrs:{"d":"M11.78 12.953a3.36 3.36 0 0 0-1.268-1.574 3.64 3.64 0 0 0-1.984-.612 3.64 3.64 0 0 0-1.999.565 3.38 3.38 0 0 0-1.309 1.542m5.313-4.29a2.157 2.157 0 1 1-4.313 0 2.157 2.157 0 0 1 4.313 0Z"}})])])
          )
        }
      }
    